export const selectTimer = (state: any, timerType: string) => state.idleTimer.timers[timerType];